import { mapGetters } from 'vuex';

export default {
  data: () => ({
    defaultRuleColor: '#96d3ad',
    repeatOptions: [
      {
        text: 'Entire Range',
        value: 0
      },
      {
        text: 'Specific Dates',
        value: 1
      },
      {
        text: 'Specific Days',
        value: 2
      },
      {
        text: 'Specific Months',
        value: 3
      },
      {
        text: 'Annual Dates',
        value: 4
      }
    ],
    rateTypes: [
      {
        text: '1 - Specialty Rates',
        value: 1
      },
      {
        text: '2 - Holidays & Events Rates',
        value: 2
      },
      {
        text: '3 - Weekend & Week Days Rates',
        value: 3
      },
      {
        text: '4 - Seasonality Rate',
        value: 4
      },
      {
        text: '5 - Default Rate',
        value: 5
      }
    ],
    tooltips: {
      0: 'Occur on every day within date range',
      1: 'Occur only on specific dates within date range (Example: every 10th, 11th, 12th)',
      2: 'Occur on specific days of the week within date range (Example: every Fri, Sat, Sun)',
      3: 'Occur on specific months with in date range (Example: every May, June, July)',
      4: 'Occur on specific dates annually (Example: every December 25)'
    }
  }),

  computed: {
    ...mapGetters([
      'getUnits',
      'getUnitPricingRules'
    ]),

    locale () {
      return localStorage.getItem("locale") || 'en';
    },

    dateOptions () {
      return new Array(31)
        .fill(0)
        .map((_, i) => ({
          value: i + 1 < 10 ? `0${ i + 1 }` : `${ i + 1 }`,
          text: i + 1
        }));
    },

    weekOptions () {
      return this.$moment.localeData(this.locale).weekdaysShort()
        .map((item, i) => ({
          value: `${ i }`,
          text: item
        }));
    },

    monthOptions () {
      return this.$moment.localeData(this.locale).monthsShort()
        .map((item, i) => ({
          value: i + 1 < 10 ? `0${ i + 1 }` : `${ i + 1 }`,
          text: item
        }));
    },

    unitList() {
      return this.getUnits
        .map(unit => ({
          id: unit.id,
          name: unit.unit_name
        }))
    }
  },

  methods: {
    formatDate(value, format = 'MMMM D, YYYY') {
      let date_ = this.$moment(value);

      if (!date_.isValid()) {
        return '';
      }

      return date_.format(format);
    },

    getRepeatTypeName(value) {
      let repeat_option = this.repeatOptions
        .find(option => option.value === value);

      if (repeat_option) {
        return repeat_option.text;
      }

      return '';
    },

    getRepeatOnLabels(type, repeat_on) {
      if (type < 1 || !repeat_on) {
        return repeat_on;
      }

      let items = repeat_on.split(', ') || [];

      if (type === 1) {
        return items
          .map(i => parseInt(i))
          .join(', ');
      }

      if (type === 2) {
        return items
          .map(i => this.weekOptions[parseInt(i)].text)
          .join(', ');
      }

      if (type === 3) {
        return items
          .map(i => this.monthOptions[parseInt(i) - 1].text)
          .join(', ');
      }

      if (type === 4) {
        let year = this.$moment().format('YYYY');
        return items
          .map(item => this.$moment(`${ year }-${ item }`).format('MMM D'))
          .join(', ');
      }

      return ''
    },

    getRateTypeName(value) {
      const rate_type = this.rateTypes.find(rate_type => rate_type.value === value);

      return rate_type
        ? rate_type.text
        : '';
    },

    getPricingRules(unit_id, date) {
      if (!unit_id) {
        return [];
      }

      let rules = this.getUnitPricingRules[unit_id] || [];

      if (!date) {
        return rules;
      }

      let date_object = this.$moment(date);
      let full_date = date_object.format('YYYY-MM-DD');
      let month_date_ = date_object.format('MM-DD');
      let month_ = date_object.format('MM');
      let date_ = date_object.format('DD');
      let day_ = date_object.weekday();

      return rules
        .filter(rule_ => {
          if (rule_.starts_at && rule_.starts_at > full_date) {
            return false;
          }

          if (rule_.ends_at && rule_.ends_at < full_date) {
            return false;
          }

          if (rule_.repeat_type === 0) {
            return true;
          }

          if (rule_.repeat_type === 1) {
            return rule_.repeat_on.indexOf(date_) > -1;
          }

          if (rule_.repeat_type === 2) {
            return rule_.repeat_on.indexOf(day_) > -1;
          }

          if (rule_.repeat_type === 3) {
            return rule_.repeat_on.indexOf(month_) > -1;
          }

          if (rule_.repeat_type === 4) {
            return rule_.repeat_on.indexOf(month_date_) > -1;
          }
        });
    },

    getReservationRate(unit_id, unit_rate, starts_at, ends_at) {
      let start_date = this.$moment(starts_at);
      let end_date = this.$moment(ends_at);

      if (
        !start_date.isValid() ||
        !end_date.isValid() ||
        start_date > end_date
      ) {
        return 0;
      }

      let dates = new Array(end_date.diff(start_date, 'days'))
        .fill(0)
        .map((_, i) => (
          start_date
            .clone()
            .add(i, 'days')
            .format('YYYY-MM-DD')
        ));

      let rate_sum = 0;

      dates.map(date => {
        let rules = this.getPricingRules(unit_id, date);

        if (rules.length) {
          rate_sum += parseFloat(rules[0].rate);
        } else {
          rate_sum += parseFloat(unit_rate);
        }
      });

      return rate_sum;
    }
  }
};
